export default function getMiniactivityConf(activityConf) {
  return {
    miniactivityType: activityConf.miniactivityType,
    level: activityConf.options?.level || 'easy',
    mode: activityConf.options?.mode,
    themes: activityConf.themes,
  };
}
